import { render } from "./VisorCAD2.vue?vue&type=template&id=1c4f2558&scoped=true"
import script from "./VisorCAD2.vue?vue&type=script&lang=js"
export * from "./VisorCAD2.vue?vue&type=script&lang=js"

import "./VisorCAD2.vue?vue&type=style&index=0&id=1c4f2558&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4f2558"]])

export default __exports__